import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import { mediaSection } from "../../portfolio.js";
import "./MediaPage.css";

function MediaCard({ item, theme }) {
  return (
    <a
      className="media-page-card"
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ backgroundColor: theme.highlight }}
    >
      {item.thumbnail_url ? (
        <div className="media-page-card-thumb">
          <img src={item.thumbnail_url} alt={item.title} />
        </div>
      ) : (
        <div
          className="media-page-card-thumb media-page-card-thumb-placeholder"
          style={{
            backgroundColor: theme.body,
            borderBottom: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          <span
            className="iconify media-page-card-icon"
            data-icon={item.icon || "mdi:newspaper-variant-outline"}
            style={{ color: theme.secondaryText }}
            data-inline="false"
          ></span>
        </div>
      )}
      <div className="media-page-card-body">
        <div className="media-page-card-top">
          <span
            className="media-page-card-type"
            style={{
              backgroundColor:
                item.type === "video"
                  ? "#E53935"
                  : item.type === "audio"
                  ? "#FB8C00"
                  : item.type === "event"
                  ? "#1E88E5"
                  : "#43A047",
            }}
          >
            {item.type === "video"
              ? "\u25B6 Video"
              : item.type === "audio"
              ? "\u266A Audio"
              : item.type === "event"
              ? "\u2605 Event"
              : "\u25A0 Article"}
          </span>
          <span
            className="media-page-card-date"
            style={{ color: theme.secondaryText }}
          >
            {item.date}
          </span>
        </div>
        <h3 className="media-page-card-outlet" style={{ color: theme.text }}>
          {item.name}
        </h3>
        <p className="media-page-card-title" style={{ color: theme.text }}>
          {item.title}
        </p>
      </div>
    </a>
  );
}

class MediaPage extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="media-page-main">
        <Header theme={theme} />
        <div className="media-page-header">
          <Fade bottom duration={1000} distance="20px">
            <h1 className="media-page-title" style={{ color: theme.text }}>
              {mediaSection.title}
            </h1>
            <p
              className="subTitle media-page-subtitle"
              style={{ color: theme.secondaryText }}
            >
              {mediaSection.description}
            </p>
          </Fade>
        </div>

        <Fade bottom duration={1000} distance="20px">
          <h2 className="media-section-heading" style={{ color: theme.text }}>
            Featured &amp; Personal
          </h2>
        </Fade>
        <div className="media-page-grid">
          {mediaSection.personal.map((item, i) => (
            <Fade bottom duration={1000} distance="20px" key={`p-${i}`}>
              <MediaCard item={item} theme={theme} />
            </Fade>
          ))}
        </div>

        <Fade bottom duration={1000} distance="20px">
          <h2 className="media-section-heading" style={{ color: theme.text }}>
            Artiso AI Coverage
          </h2>
        </Fade>
        <div className="media-page-grid">
          {mediaSection.artiso.map((item, i) => (
            <Fade bottom duration={1000} distance="20px" key={`a-${i}`}>
              <MediaCard item={item} theme={theme} />
            </Fade>
          ))}
        </div>

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default MediaPage;
